<template>
  <div class="recruitment-new-company mb-4">
    <div class="d-flex align-center justify-space-between mb-3">
      <strong>{{ $t("recruitment.requirementDrawer.newCompany") }}</strong>
      <v-btn icon size="x-small" variant="text" @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-text-field
      :model-value="modelValue"
      :label="$t('recruitment.requirementDrawer.companyName')"
      density="compact"
      hide-details="auto"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script>
export default {
  name: "RecruitmentNewCompanyEditor",
  props: { modelValue: { type: String, default: "" } },
  emits: ["update:modelValue", "close"],
};
</script>

<style scoped>
.recruitment-new-company {
  background: rgba(var(--v-theme-on-surface), 0.02);
  border: 1px solid rgba(var(--v-theme-on-surface), 0.1);
  border-radius: var(--app-radius-base);
  padding: 16px;
}
</style>
